import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
import styles from "./SubscriptionPage.module.css"
import Subscription from "@components/SubscriptionPage/Subscription"

function SubscriptionPage() {
  return (
    <NavigationsPage>
      <PageWrapper className={styles.manageAppointmentPage}>
        <Subscription />
      </PageWrapper>
    </NavigationsPage>
  )
}

export default SubscriptionPage
